// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo, useState } from "react";
import { Stack, useMediaQuery, useTheme } from "@mui/material";
import {
  GridColDef,
  GridRowId,
  GridRenderCellParams,
  GridActionsCellItem,
  GridPaginationModel,
} from "@mui/x-data-grid";
import { DeleteConfirmModal, Table } from "../../molecules";
import { Loading, StatusBar, StatusBarUser } from "../../atoms";
import {
  DeleteCommissionParameterRequest,
  IMasterPassListItem ,
  useDeleteMasterPass,
  PagingResponse,
 useGetMasterPassListForPage,
  useAuthorization,
} from "../../../hooks";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CloseIcon from "@mui/icons-material/Close";
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { useNavigate } from "react-router-dom";
import { downloadExcel } from "../../../util/downloadExcel";
import { useUserInfo } from "../../../store/User.state";
import dayjs from "dayjs";

function RenderStatus(props: GridRenderCellParams<any, string>) {
  const { value } = props;

  return <>{value && <StatusBarUser status={value} />}</>;
}
function RenderCheckBar(props: GridRenderCellParams<any, string>) {
  const { value } = props;

  return value ? (
    <CheckCircleOutlineIcon style={{ color: "#00B0A6" }} />
  ) : (
    <CloseIcon style={{ color: "#F5004A" }} />
  );
}

type BankCommissionListingTableProps = {
  onRowClick?: (data: { id: GridRowId; row: IMasterPassListItem  }) => void;
};

export const MasterPassListingTable = ({
  onRowClick,
}: BankCommissionListingTableProps) => {
  const theme = useTheme();
  const {showDelete, showUpdate} = useAuthorization();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const [queryOptions, setQueryOptions] = React.useState({});
  const [tableData, setTableData] =
    useState<PagingResponse<Array<IMasterPassListItem >>>();
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 25,
  });
  const { mutate: getMasterPassListForPage, isLoading } =
 useGetMasterPassListForPage();
  const navigate = useNavigate();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(0);
  const [shouldRefresh, setShouldRefresh] = React.useState(false);
  const setSnackbar = useSetSnackBar();
  const { mutate: masterPassDelete, isLoading: isDeleteLoading } =
    useDeleteMasterPass();
    const [userInfo] = useUserInfo();




    useEffect(() => {
      const savedFilter = localStorage.getItem("masterPassListingFilter");
      if (savedFilter) {
        setQueryOptions(JSON.parse(savedFilter));
      }
    }, []);



  useEffect(() => {
    const requestPayload = {
      size: paginationModel.pageSize,
        page: paginationModel.page,
        orderBy: "CreateDate",
        orderByDesc: true,
        status: "ACTIVE",
        merchantId: Number(userInfo.merchantId),
        ...getQueryParams(queryOptions),
    };
    if (queryOptions?.field && queryOptions?.value !== undefined) {
      requestPayload[queryOptions.field] = queryOptions.value;
    }

    getMasterPassListForPage(
  requestPayload,
      {
        onSuccess: (data) => {
          if (data.isSuccess) {
            setTableData(data?.data);
          } else {
            setTableData(data?.data);
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      }
    );
  }, [
    getMasterPassListForPage,
    paginationModel.page,
    paginationModel.pageSize,
    setSnackbar,
    queryOptions,
    shouldRefresh,
  ]);

  const handleChangePagination = (model: GridPaginationModel) => {
    setPaginationModel(model);
    setTableData(undefined);

    getMasterPassListForPage(
      {
        size: paginationModel.pageSize,
        page: paginationModel.page,
        orderBy: "CreateDate",
        orderByDesc: true,
        status: "ACTIVE",
        merchantId: Number(userInfo.merchantId),
      },
      {
        onSuccess: (data) => {
          if (data.isSuccess) {
            setTableData(data?.data);
          } else {
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      }
    );
  };

  const editRow = React.useCallback(
    (masterPassProfile: IMasterPassListItem ) => () => {
      navigate("/merchant-management/masterpass-identification-detail", {
        state: masterPassProfile,
      });
    },
    [navigate]
  );
  
  const deleteRow = React.useCallback(
    (masterPass: any) => () => {
      setIsDeleteModalOpen(true);
      setSelectedRowId(Number(masterPass.id));
    },
    []
  );

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  const handleDeleteConfirm = () => {
    const deleteRequest: DeleteMasterPassRequest = {
      id: selectedRowId,
    };

    masterPassDelete(deleteRequest, {
      onSuccess: (data: any) => {
        if (data.isSuccess) {
          setShouldRefresh(prev => !prev);
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });

    handleCloseDeleteModal();
  };

  const columns: GridColDef[] = useMemo(() => {
    return [
      {
        field: "Aksiyonlar",
        type: "actions",
        width: 80,
        getActions: (params) => {
          if (params.row.status === "PASSIVE") {
            return [];
          }
          return [
            !!showUpdate ? <GridActionsCellItem
              onClick={editRow(params.row)}
              label="Düzenle"
              showInMenu
            /> : null,
            // !!showDelete ? <GridActionsCellItem
            //   label="Sil"
            //   onClick={deleteRow(params.row)}
            //   showInMenu
            // /> : null,
          ].filter(Boolean); 
        }
      },
      { field: "merchantId", headerName: "Üye İşyeri Numarası", width: 200 },
      { field: "merchantName", headerName: "Üye İşyeri Adı", width: 200 },
      { field: "clientId", headerName: "MasterPass Üye İşyeri Numarası", width: 200 },
       
      { field: "encKey", headerName: "EncKey", width: 300 },
      { field: "macKey", headerName: "MacKey", width: 300 },
      { field: "terminalGroupId", headerName: "MasterPass Terminal Grup Id", width: 300 },
      
      {
        field: "restriction", 
        headerName: "Yetki", 
        width: 200,
        renderCell: (params) => {
          return params.value ? "Evet" : "Hayır";
        }
      },
      {
        field: "createDate",
        headerName: "Oluşturma Tarihi",
        width: 200,
        renderCell: (params) => {
          if (!params.value) return "";
          const formattedDate = dayjs(params.value).format("DD.MM.YYYY HH:mm");
          if (formattedDate === "Invalid Date") return "";
          return formattedDate;
        },
      },
      { field: "createUserName", headerName: "Oluşturan Kullanıcı", width: 200 },

      {
        field: "updateDate",
        headerName: "Son Güncellenme Tarihi",
        width: 200,
        renderCell: (params) => {
          if (!params.value) return "";
          const formattedDate = dayjs(params.value).format("DD.MM.YYYY HH:mm");
          if (formattedDate === "Invalid Date") return "";
          return formattedDate;
        },
      },
      { field: "updateUserName", headerName: "Son Güncelleyen Kullanıcı", width: 200 },


      // {  renderCell: RenderStatus,   field: "status", headerName: "Durum", width: 200 },


    ];
  }, [deleteRow, editRow, showDelete, showUpdate]);
  const keyMapping = {
    restriction: "Yetki",
  };
  const onSave = () => {
    const requestPayload = {
      size: -1,
      page: 0,
      orderBy: "CreateDate",
      orderByDesc: true,
      status: "ACTIVE",
      merchantId: Number(userInfo.merchantId),
      ...getQueryParams(queryOptions),
    };

    if (queryOptions?.field && queryOptions?.value !== undefined) {
      requestPayload[queryOptions.field] = queryOptions.value;
    }
    getMasterPassListForPage(
   requestPayload,
      {
        onSuccess: (data) => {
          if (data.isSuccess) {
            function fieldValue(data) {
              return data.map((item) => {
                return {
                  "Üye İşyeri Numarası": item?.merchantId,
                  "Üye İşyeri Adı": item?.merchantName,
                  "MasterPass Üye İşyeri Numarası": item?.clientId,
                  "EncKey": item?.encKey,
                  "MacKey": item?.macKey,
                  "MasterPass Terminal Grup Id": item?.terminalGroupId,
             
                  [keyMapping["restriction"]]: item?.restriction ? "Evet" : "Hayır",
                  "Oluşturma Tarihi": item?.createDate ? dayjs(item?.createDate).format("DD.MM.YYYY HH:mm") : "",
                  "Oluşturan Kullanıcı": item?.createUserName,
                  "Son Güncellenme Tarihi": item?.updateDate ? dayjs(item?.updateDate).format("DD.MM.YYYY HH:mm") : "",
                  "Son Güncelleyen Kullanıcı": item?.updateUserName,
                 
           
                };
              });
            }
            const refactoredData = fieldValue(data?.data?.result );
            downloadExcel(refactoredData || [], "Masterpass Üye İşyeri Listeleme", keyMapping);
          } else {
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      }
    );
  };
  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(null, args);
      }, delay);
    };
  };

  const getQueryParams = (filters) => {
    const queryParams = {};

    for (let key in filters) {
      if (filters[key]?.toString()?.length >= 1) {
        queryParams[key] = filters[key];
      }
    }

    return queryParams;
  };

  const handleFilterChange = debounce((filters) => {
    if (filters.clearFilter) {
      localStorage.removeItem('masterPassListingFilter')
      return setQueryOptions({});
    }
  
    const queryParams = getQueryParams(filters);
    const allValuesAtLeastThreeChars = Object.values(queryParams).every((value) => value?.toString().length >= 3);
    const atLeastOneValueThreeChars = Object.values(queryParams).some((value) => value?.toString().length >= 3);
    
    const previousKeysLength = Object.keys(previousQueryParams.current).length;
    const currentKeysLength = Object.keys(queryParams).length;
  
    // Eğer queryParams bir önceki ile aynıysa işlem yapma
    if (JSON.stringify(previousQueryParams.current) === JSON.stringify(queryParams)) {
      return;
    }
  
    if ((allValuesAtLeastThreeChars || (atLeastOneValueThreeChars && previousKeysLength > currentKeysLength))) {
      setQueryOptions(queryParams);
      localStorage.setItem('masterPassListingFilter', JSON.stringify(queryParams))
    }
  
    // Son olarak, mevcut queryParams değerini bir önceki değer olarak set edin
    previousQueryParams.current = queryParams;
  
  }, 500);
  const hasActiveFilters = Object?.keys(queryOptions)?.length > 0;
  // Komponent içerisinde
  const previousQueryParams = React.useRef({});

  const hasLoading = isLoading || isDeleteLoading;
  return (
    <>
      {hasLoading && <Loading />}
      <Stack flex={1} p={2} justifyContent="space-between">

          <>
            <Table
             columnVisibilityConfigKey="masterPassListingColumnVisibilityKey"
            filterKey="masterPassListingFilter"
            hasActiveFilters={hasActiveFilters}
             handleFilterChange={handleFilterChange}
              paginationModel={paginationModel}
              onPaginationModelChange={handleChangePagination}
              paginationMode="server"
              rowCount={tableData?.totalItems || 0}
              sx={{ width: isDesktop ? 1308 : window.innerWidth - 50 }}
              onRowClick={onRowClick}
              isRowSelectable={() => false}
              // disableColumnMenu
              rows={tableData?.result || []}
              columns={columns}
              getRowClassName={(params) => {
                if (params?.row?.restriction === false) return 'blocked-row'
                // if (params.row.status === 'PASSIVE') return  'blocked-row';
                // if (params.row.status === 'BLOCKED') return  'pasive-row';
                return '';
            }}
              exportFileName="Masterpass Üye İşyeri Listeleme"
              onSave={() => onSave()}
            />
            <DeleteConfirmModal
              isOpen={isDeleteModalOpen}
              onClose={handleCloseDeleteModal}
              onConfirm={() => handleDeleteConfirm()}
            ></DeleteConfirmModal>
          </>

      </Stack>
    </>
  );
};
